import { CommonModule } from "@angular/common";
import { NgModule, Type } from "@angular/core";
import { CoreDirectivesModule } from "../_core/_core.directives.module";
import { MiscDirectivesModule } from "../_misc/_misc.directives.module";
import { VeriDirectivesModule } from "../_veri/_veri.directives.module";
import { ActiveRangeBarChartComponent } from "./activeRangeBarChart/active-range-bar-chart.component";
//import { GaugeComponent } from "./gauge/gauge.component";


const privateComponents: Type<any>[] = [

];

const publicComponents: Type<any>[] = [
    ActiveRangeBarChartComponent
    //GaugeComponent
];

const providers: any[] = [

];

@NgModule({
    imports: [
        CommonModule,
        VeriDirectivesModule,
        CoreDirectivesModule,
        MiscDirectivesModule
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents],
    exports: [...publicComponents]
})
export class VisualisationsModule {
    constructor() {
    }
}
